import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

let refreshing = null;
axios.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config || {};
  if (err.response?.status !== 401 || cfg._retry || cfg.url?.includes("/auth/")) throw err;
  cfg._retry = true;
  refreshing = refreshing || axios.post(`${API}/auth/refresh`).finally(() => { refreshing = null; });
  await refreshing;
  return axios(cfg);
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d);
};

const get = (u) => axios.get(`${API}${u}`).then((r) => r.data);
const post = (u, b) => axios.post(`${API}${u}`, b).then((r) => r.data);

export const authApi = {
  me: () => get("/auth/me"),
  login: (email, password) => post("/auth/login", { email, password }),
  mfa: (mfa_token, code) => post("/auth/mfa/verify", { mfa_token, code }),
  logout: () => post("/auth/logout"),
  forgot: (email) => post("/auth/forgot-password", { email }),
  reset: (token, password) => post("/auth/reset-password", { token, password }),
  invite: (token) => get(`/invitations/${token}`),
  accept: (token, password) => post(`/invitations/${token}/accept`, { password }),
};

export const adminApi = {
  stats: () => get("/admin/stats"),
  invitations: () => get("/admin/invitations"),
  invite: (name, email, data) => post("/admin/invitations", { name, email, data }),
  resend: (id) => post(`/admin/invitations/${id}/resend`),
  revoke: (id) => axios.delete(`${API}/admin/invitations/${id}`).then((r) => r.data),
  submissions: (q = "") => get(`/admin/submissions?q=${encodeURIComponent(q)}`),
  portalClients: () => get("/admin/portal-clients"),
  submission: (id) => get(`/admin/submissions/${id}`),
  review: (id) => post(`/admin/submissions/${id}/review`),
  shareReport: (id) => post(`/admin/submissions/${id}/share`),
  notes: (cid) => get(`/admin/clients/${cid}/notes`),
  addNote: (cid, text) => post(`/admin/clients/${cid}/notes`, { text }),
  deleteNote: (id) => axios.delete(`${API}/admin/notes/${id}`).then((r) => r.data),
  settings: () => get("/admin/settings"),
  saveSettings: (s) => axios.put(`${API}/admin/settings`, s).then((r) => r.data),
};

export const portalApi = {
  me: () => get("/portal/me"),
  save: (data, progress) => axios.put(`${API}/portal/draft`, { data, progress }).then((r) => r.data),
  submit: (privacy_version) => post("/portal/submit", { consent: true, privacy_version }),
  report: () => get("/portal/report"),
};

export const api = {
  list: () => axios.get(`${API}/clients`).then((r) => r.data),
  get: (id) => axios.get(`${API}/clients/${id}`).then((r) => r.data),
  create: (data) => axios.post(`${API}/clients`, { data }).then((r) => r.data),
  update: (id, data) => axios.put(`${API}/clients/${id}`, { data }).then((r) => r.data),
  duplicate: (id) => axios.post(`${API}/clients/${id}/duplicate`).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/clients/${id}`).then((r) => r.data),
};

export const productsApi = {
  list: () => axios.get(`${API}/products`).then((r) => r.data),
  create: (p) => axios.post(`${API}/products`, p).then((r) => r.data),
  update: (id, p) => axios.put(`${API}/products/${id}`, p).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/products/${id}`).then((r) => r.data),
};

export const PRODUCT_CATEGORIES = ["Life insurance", "Disability insurance", "Critical illness", "Retirement savings"];
export const REC_CATEGORY = { life: "Life insurance", di: "Disability insurance", ci: "Critical illness", retirement: "Retirement savings" };
